// @flow
export const APP_BAR_TOGGLE_MOBILE_LOCATION_SEARCH =
  'appBar/TOGGLE_MOBILE_LOCATION_SEARCH';

export function toggleMobileLocationSearch(mobileLocationSearchShown) {
  return {
    type: APP_BAR_TOGGLE_MOBILE_LOCATION_SEARCH,
    mobileLocationSearchShown,
  };
}



// WEBPACK FOOTER //
// ./actions/appBar.js